import React, { useState, useEffect, useRef } from 'react'
import styled from 'styled-components'
import parse from 'html-react-parser'
import 'animate.css';
import { useParams } from 'react-router-dom';
//Componentes
import FlexContainer from '../components/common/FlexContainer'
import Titulo from '../components/ova/Titulo'
import Subtitulo from '../components/ova/Subtitulo'
import Texto from '../components/ova/Texto'
import Button, { CustomButton } from '../components/common/Button'
import Imagen from '../components/ova/Imagen'
import TextoImagen from '../components/ova/TextoImagen'
import Tarjetas from '../components/ova/Tarjetas'
import Referencias from '../components/ova/Referencias'
import Video from '../components/ova/Video'
import Scratch from '../components/ova/Scratch';
import ActividadOrdenar from '../components/ova/ActividadOrdenar/ActividadOrdenar';
import ActividadRelacionar from '../components/ova/ActividadRelacionar';
import ActividadArrastrar from '../components/ova/ActividadArrastrar/ActividadArrastrar';
import CasoPractico from '../components/ova/CasoPractico/CasoPractico';
import Loader from '../components/common/Loader';
//Navigation
import AsideNavigation from '../components/ova/AsideNavigation'

//Servicios
import OvaService from '../services/OvaService'
import ProgresoService from '../services/ProgresoService';




export default function Ova() {

    //Params
    let { _id } = useParams();

    //Estados
    const [index, setIndex] = useState(0);
    const [pagina, setPagina] = useState([]);
    const [info, setInfo] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isOk, setIsOk] = useState(true);
    const [progreso, setProgreso] = useState("");
    const [pistas, setPistas] = useState(0);

    //Manipuladores de página 
    const next = (e) => {
        if (!loading) {
            const nexIndex = index === info.length - 1 ? 0 : index + 1;
            setIndex(nexIndex);
            setPagina(info[nexIndex]);
            scrollToTop();
            guardarProgreso(index);
            if (info[nexIndex][0].tipo == "titulo") {
                setIsOk(true);
            }
        }
    }

    const previous = (e) => {
        if (!loading) {
            const nexIndex = index === 0 ? info.length - 1 : index - 1;
            setIndex(nexIndex);
            setPagina(info[nexIndex]);
            scrollToTop();
            guardarProgreso(index);
            if (info[nexIndex][0].tipo == "titulo") {
                setIsOk(true);
            }
        }
    }

    const pageNavigate = (index) => {
        setIndex(index);
        setPagina(info[index]);
        scrollToTop();
        console.log();
        if (info[index][0].tipo == "titulo") {
            setIsOk(true);
        }
    }



    //Guardar Progreso
    function guardarProgreso(index) {
        if (typeof progreso[index] == 'object') {
            if (isOk) {
                progreso[index].success = true;
                progreso[index].pistas = pistas;
            }
        } else {
            progreso[index] = true;
        }
        ProgresoService.guardarProgreso([{ "estado": progreso }], _id).then((res) => {
        })
    }

    //Cargar información a los estados de página e info
    useEffect(() => {
        setLoading(true);
        OvaService.obtenerOva(_id).then(res => {
            setPagina(res.Respuesta[0].content[0]);
            setInfo(res.Respuesta[0].content);
            setLoading(false);
        })

        ProgresoService.obtenerProgreso().then(res => {
            setProgreso(res[0].grupos[0].progreso[_id]);
        })

    }, [setInfo, setPagina]);


    //Scroll
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    const items = pagina.map((item, index) => {
        switch (item.tipo) {
            case "titulo":
                return <Titulo backgroundColor={item.style.backgroundColor} color={item.style.color} key={index}>{item.contenido.data}</Titulo>
            case "subtitulo":
                return <Subtitulo backgroundColor={item.style.backgroundColor} color={item.style.color} key={index}>{item.contenido.data}</Subtitulo>
            case "texto":
                return <Texto backgroundColor={item.style.backgroundColor} color={item.style.color} key={index}>{parse(item.contenido.data)}</Texto>
            case "imagen":
                return <Imagen src={item.contenido.url} backgroundColor={item.style.backgroundColor} width={item.style.width} key={index}></Imagen>
            case "textoimagen":
                return <TextoImagen src={item.contenido.url} width={item.style.width} backgroundColor={item.style.backgroundColor} color={item.style.color} key={index}>{parse(item.contenido.data)}</TextoImagen>
            case "tarjetas":
                return <Tarjetas items={item.contenido.tarjetas} backgroundColor={item.style.backgroundColor} color={item.style.color} grid={item.style.grid} key={index}></Tarjetas>
            case "referencias":
                return <Referencias items={item.contenido.data} backgroundColor={item.style.backgroundColor} color={item.style.color} key={index}></Referencias>
            case "video":
                return <Video src={`${item.contenido.url}?rel=0`} backgroundColor={item.style.backgroundColor} key={index}></Video>
            case "scratch":
                return <Scratch src={item.contenido.url} backgroundColor={item.style?.backgroundColor} key={index}></Scratch>
            case "actividadordenar":
                return <ActividadOrdenar data={item.contenido} isOk={isOk} setIsOk={setIsOk} pistas={pistas} setPistas={setPistas} key={index}></ActividadOrdenar>
            case "actividadrelacionar":
                return <ActividadRelacionar data={item.contenido} isOk={isOk} setIsOk={setIsOk} pistas={pistas} setPistas={setPistas} key={index}></ActividadRelacionar>
            case "actividadarrastrar":
                return <ActividadArrastrar data={item.contenido} isOk={isOk} setIsOk={setIsOk} pistas={pistas} setPistas={setPistas} key={index}></ActividadArrastrar>
            case "casopractico":
                return <CasoPractico data={item.contenido} key={index}></CasoPractico>
            default:
                break;
        }
    }

    );

    return (
        <FlexContainer flexDirection='row' alignItems='top' height="100%">
            <FlexContainer textAlign='left' backgroundColor='var(--color-morado-oscuro)' width='75%'>
                {!loading &&
                    <>
                        {items}
                        <FlexContainer flexDirection='row' backgroundColor='transparent'>
                            <CustomButton width='10%' onClick={previous} disabled={index == 0 ? true : false}>Anterior</CustomButton>
                            <Mark>{index + 1} / {info.length}</Mark>
                            <CustomButton width='10%' onClick={next} disabled={!isOk}>Siguiente</CustomButton>
                        </FlexContainer>
                    </>
                }{loading &&
                    <FlexContainer flexDirection='column' backgroundColor='transparent' minHeight='100vh'>
                        <Message>Cargando</Message>
                        <Loader></Loader>
                    </FlexContainer>
                }
            </FlexContainer>
            <AsideNavigation data={info} pageIndex={index} pageNavigate={pageNavigate} progreso={progreso} setProgreso={setProgreso} _id={_id} guardarProgreso={guardarProgreso}></AsideNavigation>
        </FlexContainer>
    )
}

const Mark = styled.span`
    color: var(--color-blanco);
`;
const Message = styled.h1`
    color: var(--color-blanco);
`;

